import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, startWith, switchMap } from 'rxjs/operators';
import { ColumnDefinition } from 'src/app/dto/columnDefinition';
import { Dealer } from 'src/app/models/dealer.model';
import { ClickStreamService } from 'src/app/services/click-stream.service';
import { DealersService } from 'src/app/services/dealers.service';

@Component({
  selector: 'app-choose-users-table',
  templateUrl: './choose-users-table.component.html',
  styleUrls: ['./choose-users-table.component.scss']
})
export class ChooseUsersTableComponent implements OnInit {

  columns: ColumnDefinition[] = [
    { columnDef: 'name', header: 'Name', cell: (w: any) => `${w.name}` },
    { columnDef: 'vendorId', header: 'BAC', cell: (w: any) => `${w.vendorId}` },
    { columnDef: 'region', header: 'Region', cell: (w: any) => `${w.region}` },
    { columnDef: 'zone', header: 'Zone', cell: (w: any) => `${w.zone}` },
    // { columnDef: 'vendorCode', header: 'Vendor Code', cell: (w: any) => `${w.vendorCode}` },
    { columnDef: 'district', header: 'District', cell: (w: any) => `${w.district}` }
  ];

  @Input() dealers: Dealer[];
  @Input() filterOut: any[];
  @Input() currentOffset: number;
  @Input() currentTake: number;
  @Input() entityId: number;
  selectedRegion: string;

  @Input() selection: SelectionModel<any>;
  @Input() selectedRegionFilter: string;
  @Output() selectedRegionFilterChange = new EventEmitter<string>();
  @Input() selectedZoneFilter: string;
  @Output() selectedZoneFilterChange = new EventEmitter<string>();
  @Input() selectedDistrictFilter: string;
  @Output() selectedDistrictFilterChange = new EventEmitter<string>();
  @Input() clickstreamPageTitle: string;
  @Input() dealerTableHeight = '400px';

  searchInput: string;

  regionSearchValues: any;
  regionFilterControl = new FormControl();
  regionFilter: string;

  zoneSearchValues: any;
  zoneFilterControl = new FormControl();
  zoneFilter: string;

  districtSearchValues: any;
  districtFilterControl = new FormControl();
  districtFilter: string;

  sortBy: string = 'Name';
  sortDirection: string = 'ASC';

  isLoading = false;

  constructor(private dealersService: DealersService, private clickstream: ClickStreamService) {
    this.regionFilterControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(filter => {
        return this.searchFilter("Region", filter);
      })
    )
      .subscribe(data => {
        this.regionSearchValues = data;
      });

    this.zoneFilterControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(filter => {
        return this.searchFilter("Zone", filter);
      })
    )
      .subscribe(data => {
        this.zoneSearchValues = data;
      });

    this.districtFilterControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(filter => {
        return this.searchFilter("District", filter);
      })
    )
      .subscribe(data => {
        this.districtSearchValues = data;
      });
  }

  ngOnInit() {
    document.documentElement.style.setProperty('--table-height', this.dealerTableHeight);
    if (this.selectedRegionFilter) this.regionFilter = this.selectedRegionFilter;
    if (this.selectedZoneFilter) this.zoneFilter = this.selectedZoneFilter;
    if (this.selectedDistrictFilter) this.districtFilter = this.selectedDistrictFilter;
    this.search('');
  }

  search(searchInput: string) {
    this.currentOffset = 0;
    this.currentTake = 15;
    this.dealers = [];
    this.isLoading = true;
    this.searchInput = searchInput;
    this.dealersService.search(this.currentOffset, this.currentTake, this.searchInput, this.regionFilter, this.zoneFilter, this.districtFilter, this.sortBy, this.sortDirection).subscribe(dealers => {
      dealers.forEach(dealer => {
        this.selection.selected.forEach(selected => {
          if (dealer.guid == selected.guid) {
            this.selection.select(dealer);
            this.selection.deselect(selected)
          }
        })
      })
      this.dealers = this.filterOut ? dealers.filter(d => this.filterOut.findIndex(id => id == d.vendorId) === -1) : dealers;
      this.isLoading = false;
    })
    this.clickstream.send('search-dealers', 'search', this.clickstreamPageTitle, 'Search Text Input', '', true);
  }

  searchFilter(filter: string, input?: any) {
    this.clickstream.send('search-dealers-filters', 'search', this.clickstreamPageTitle, 'Search Filter By ' + filter, '', true)
    if (filter == 'Zone') {
      return this.dealersService.searchFilters(filter, input, this.regionFilter);
    } else if (filter == 'District') {
      return this.dealersService.searchFilters(filter, input, this.regionFilter, this.zoneFilter)
    } else {
      return this.dealersService.searchFilters(filter, input)
    }
  }

  filter(by: string, value: string) {
    if (by == 'Region') {
      this.regionFilter = value;
      this.selectedRegionFilter = value;
      this.selectedRegionFilterChange.emit(this.selectedRegionFilter);
      this.searchFilter('Zone').subscribe(res => {
        this.zoneSearchValues = res;
      });
      this.searchFilter('District').subscribe(res => {
        this.districtSearchValues = res;
      });
    }
    if (by == 'Zone') {
      this.zoneFilter = value;
      this.selectedZoneFilter = value;
      console.log('setting zone to changed', this.selectedZoneFilter);
      this.selectedZoneFilterChange.emit(this.selectedZoneFilter);
      this.searchFilter('District').subscribe(res => {
        this.districtSearchValues = res;
      });
    }
    if (by == 'District') {
      this.districtFilter = value;
      this.selectedDistrictFilter = value;
      this.selectedDistrictFilterChange.emit(this.selectedDistrictFilter);
    } 
    this.search(this.searchInput);
    this.clickstream.send('filter-dealers', 'filter', this.clickstreamPageTitle, 'FIlter By ' + by, '', true);
  }

  clearFilters() {
    this.regionFilter = undefined;
    this.regionSearchValues = [];
    this.selectedRegionFilterChange.emit('')
    this.zoneFilter = undefined;
    this.zoneSearchValues = [];
    this.selectedZoneFilterChange.emit('')
    this.districtFilter = undefined;
    this.selectedDistrictFilterChange.emit('')
    this.districtSearchValues = [];
    this.search('');
    this.clickstream.send('clear-search-filters', 'click', this.clickstreamPageTitle, 'Clear Filters', '', true);
  }

  removeSelectedGroup(dealer: any) {
    this.selection.deselect(dealer);
  }

  public onScroll() {
    this.currentOffset = this.dealers.length;
    this.currentTake += 10;
    this.refreshSearch(true);
  }

  public onSort(sortBy: string, sortDirection: string) {
    if (sortDirection) {
      if (sortBy === 'BAC') sortBy = 'vendorId';
      this.sortBy = sortBy;
      this.sortDirection = sortDirection;
      this.refreshSearch(false);
    }
  }

  refreshSearch(concat: boolean) {
    this.dealersService.search(this.currentOffset, this.currentTake, this.searchInput, this.regionFilter, this.zoneFilter, this.districtFilter, this.sortBy, this.sortDirection).subscribe((dealers: Dealer[]) => {
      dealers.forEach(dealer => {
        this.selection.selected.forEach(selected => {
          if (dealer.guid == selected.guid) {
            this.selection.select(dealer);
            this.selection.deselect(selected)
          }
        })
      })
      if (concat) this.dealers = this.dealers.concat(dealers);
      else this.dealers = dealers;
    });
  }
}
